import { axiosInstance } from '../Config/axios';

// Guardar tokens en localStorage
const saveTokens = (tokens) => {
  localStorage.setItem("access_token", tokens.access);
  localStorage.setItem("refresh_token", tokens.refresh);
};

// Obtener tokens de localStorage
export const getAccessToken = () => localStorage.getItem("access_token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");

// Eliminar tokens y cerrar sesión
export const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  window.location.reload();
};

// Login
export const login = async (username, password) => {
  try {
    const response = await axiosInstance.post('auth/token/', { username, password });
    localStorage.setItem("userData", JSON.stringify(response.data.user));
    saveTokens(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en login:", error.response?.data || error.message);
    throw error;
  }
};

// Refresh Token
export const refreshToken = async () => {
  const refresh = getRefreshToken();
  if (!refresh) {
    console.error("No hay refresh token disponible, cerrando sesión...");
    logout();
    return null;
  }

  try {
    const response = await axiosInstance.post('auth/token/refresh/', { refresh });
    const newAccessToken = response.data.access;

    if (!newAccessToken) throw new Error("No se recibió un nuevo token de acceso");

    saveTokens(response.data);
    return newAccessToken;
  } catch (error) {
    console.error("Error al refrescar el token:");
    console.error("Status:", error.response?.status);
    console.error("Data:", error.response?.data);
    console.error("Mensaje:", error.message);

    if (error.response?.status === 401) {
      console.warn("Refresh token expirado. Cerrando sesión.");
      logout();
    }

    return null;
  }
};
